import React from 'react';
import { Smartphone, Map, Bell, BarChart3, Activity } from "lucide-react";

export default function TechStack() {
  return (
    <section id="technology" className="py-24 bg-slate-50 dark:bg-slate-900/50">
      <div className="container mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          
          {/* Left: Phone Mockup */}
          <div className="lg:w-1/2 relative flex justify-center">
            <div className="relative z-10 w-[300px] h-[600px] bg-primary rounded-[3rem] border-8 border-slate-800 shadow-2xl overflow-hidden">
              <img 
                src="https://images.unsplash.com/photo-1759256243611-502772ac391b" 
                alt="App Interface" 
                className="w-full h-full object-cover opacity-90"
              />
              
              {/* Mock UI Overlay */}
              <div className="absolute bottom-0 left-0 right-0 bg-white/95 backdrop-blur-md p-6 rounded-t-3xl">
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <h4 className="font-bold text-primary">Ride to Office</h4>
                    <p className="text-xs text-muted-foreground">Arriving in 5 mins</p>
                  </div>
                  <span className="bg-green-100 text-green-700 text-xs px-2 py-1 rounded-full font-bold">On Time</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-slate-200" />
                  <div className="text-sm">
                    <p className="font-medium">Driver: Michael</p>
                    <p className="text-muted-foreground">KA-01-EQ-2234</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Decorative Circles */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-secondary/10 rounded-full blur-3xl -z-0" />
          </div>

          {/* Right: Content */}
          <div className="lg:w-1/2 space-y-10">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">Technology at Your Fingertips</h2>
              <p className="text-lg text-muted-foreground">
                Our integrated technology stack connects employees, drivers, and transport managers in real-time.
              </p>
            </div>

            <div className="grid gap-8">
              {[
                {
                  icon: Smartphone,
                  title: "Employee App",
                  desc: "Live tracking, SOS panic button, roster management, and feedback - all in one intuitive app."
                },
                {
                  icon: Map,
                  title: "Smart Routing Engine",
                  desc: "AI algorithms optimize routes daily based on traffic, occupancy, and employee shifts."
                },
                {
                  icon: Bell,
                  title: "Real-Time Alerts",
                  desc: "Instant notifications for delays, boarding, and arrival. No more waiting in the dark."
                },
                {
                  icon: BarChart3,
                  title: "Admin Dashboard",
                  desc: "Comprehensive analytics on fleet utilization, cost per trip, and on-time performance."
                },
                {
                  icon: Activity,
                  title: "Driver Behaviour Analytics",
                  desc: "Advanced monitoring of driving patterns including harsh braking, acceleration, and speeding to ensure passenger safety and vehicle longevity."
                }
              ].map((item, idx) => (
                <div key={idx} className="flex gap-4 group">
                  <div className="w-12 h-12 rounded-lg bg-white shadow-sm border border-slate-100 flex items-center justify-center flex-shrink-0 group-hover:bg-secondary group-hover:text-white transition-colors duration-300">
                    <item.icon className="h-6 w-6 text-primary group-hover:text-white" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-primary mb-2">{item.title}</h3>
                    <p className="text-muted-foreground leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
